import React from "react";
import styled from "styled-components/macro";
import { Link } from "react-router-dom";
import {
  PATTERN,
  FONT_STYLE,
  SPACING,
  SPRITE,
  DEVICE,
  KEYFRAMES,
  ROTATE
} from "../constants";
import Header from "./Header";
import data from "../content.json";

const EndingContainer = styled.div`
  ${PATTERN.FLEXCONTAINER}
  flex-direction: column;
  align-items: flex-start;
  flex-wrap: nowrap;
`;

const MobileMessage = styled.div`
  ${ROTATE.MESSAGE};
`;

const MobileHeadline = styled.h1`
  display: inline-block;
  ${FONT_STYLE.QUIZ_HEADLINE}
`;

const MobileBody = styled.p`
  display: inline-block;
  ${FONT_STYLE.QUIZ_BODY}
  margin: 0.5em 0 2em;
`;

const MobileAnimation = styled.div`
  ${ROTATE.IMAGE};
`;

const ContentContainer = styled.div`
  display: none;

  @media screen and (min-width: ${DEVICE.PHONE_LANDSCAPE}) {
    flex-grow: 0;
    display: flex;
    flex-direction: column;
    width: 100%;
  }
`;

const Headline = styled.h1`
  display: none;

  @media screen and (min-width: ${DEVICE.PHONE_LANDSCAPE}) {
    display: inline-block;
    ${FONT_STYLE.QUIZ_HEADLINE}
    ${PATTERN.FADEIN}
  }
`;

const Paragraph = styled.p`
  display: none;

  @media screen and (min-width: ${DEVICE.PHONE_LANDSCAPE}) {
    display: inline-block;
    ${FONT_STYLE.QUIZ_BODY}
    margin-bottom: ${SPACING.LARGE};
    ${PATTERN.FADEIN}
    width: 100%;
    margin: 0 0 20px;
  }

  @media screen and (min-width: ${DEVICE.TABLET_LANDSCAPE}) {
    margin: 0 0 24px;
  }

  @media screen and (min-width: ${DEVICE.LAPTOP}) {
    margin: 0 0 48px;
  }
`;

const Options = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
  margin: 0 auto 0;
  ${PATTERN.FADEIN}
  flex-grow: 1;

  @media screen and (min-width: ${DEVICE.TABLET_PORTRAIT}) {
    width: 90%;
  }

  @media screen and (min-width: ${DEVICE.TABLET_LANDSCAPE}) {
    width: 90%;
  }
`;

const Option = styled.div`
  display: none;

  @media screen and (min-width: ${DEVICE.PHONE_LANDSCAPE}) {
    width: 40%;
    max-width: 400px;
    display: flex;
  }

  @media screen and (min-width: ${DEVICE.TABLET_PORTRAIT}) {
    width: 40%;
    margin: 2em auto 0;
  }
`;

const OptionImage = styled.div`
  width: 100%;
  height: 10vw;
  margin: 0 auto 10px;

  ${props => (props.type === "trophy" ? SPRITE.TROPHY : SPRITE.CHAT)}
`;

const OptionText = styled.p`
  ${FONT_STYLE.OPTION}
  margin: 0;
  position: relative;
  padding-right: 1.6em;

  &::after {
    ${PATTERN.CHEVRON}
  }
`;

const OptionExternalLink = styled.a`
  text-decoration: none;

  &:hover {
    p::after {
      animation: ${KEYFRAMES.CHEVRON} 0.25s infinite alternate;

      @media screen and (min-width: ${DEVICE.PHONE_LANDSCAPE}) {
        animation: ${KEYFRAMES.CHEVRON_PHONE_LANDSCAPE} 0.25s infinite alternate;
      }

      @media screen and (min-width: ${DEVICE.TABLET_PORTRAIT}) {
        animation: ${KEYFRAMES.CHEVRON_TABLET_PORTRAIT} 0.25s infinite alternate;
      }

      @media screen and (min-width: ${DEVICE.TABLET_LANDSCAPE}) {
        animation: ${KEYFRAMES.CHEVRON_TABLET_LANDSCAPE} 0.25s infinite
          alternate;
      }

      @media screen and (min-width: ${DEVICE.LAPTOP}) {
        animation: ${KEYFRAMES.CHEVRON_LAPTOP} 0.25s infinite alternate;
      }
    }
  }
`;
const OptionInternalLink = styled(Link)`
  text-decoration: none;

  &:hover {
    p::after {
      animation: ${KEYFRAMES.CHEVRON} 0.25s infinite alternate;

      @media screen and (min-width: ${DEVICE.PHONE_LANDSCAPE}) {
        animation: ${KEYFRAMES.CHEVRON_PHONE_LANDSCAPE} 0.25s infinite alternate;
      }

      @media screen and (min-width: ${DEVICE.TABLET_PORTRAIT}) {
        animation: ${KEYFRAMES.CHEVRON_TABLET_PORTRAIT} 0.25s infinite alternate;
      }

      @media screen and (min-width: ${DEVICE.TABLET_LANDSCAPE}) {
        animation: ${KEYFRAMES.CHEVRON_TABLET_LANDSCAPE} 0.25s infinite
          alternate;
      }

      @media screen and (min-width: ${DEVICE.LAPTOP}) {
        animation: ${KEYFRAMES.CHEVRON_LAPTOP} 0.25s infinite alternate;
      }
    }
  }
`;

class Congrats extends React.Component {
  componentDidMount() {
    this.props.updateClickstream(data.congrats.headline.join(" "));
  }

  render() {
    return (
      <EndingContainer>
        <Header updateClickstream={this.props.updateClickstream} />
        <MobileMessage>
          <MobileHeadline>Please rotate your device.</MobileHeadline>
          <MobileBody>
            This experience is optimized for landscape mode.
          </MobileBody>
          <MobileAnimation />
        </MobileMessage>
        <ContentContainer>
          <Headline>{data.congrats.headline[0]}</Headline>
          <Paragraph>{data.congrats.body}</Paragraph>
        </ContentContainer>
        <Options>
          <Option>
            <OptionExternalLink
              href="https://onesourcedt.ubs.com/CEFSWebApp/fwwellness.do?/"
              target="_blank"
              onClick={() => {
                this.props.updateClickstream(
                  "https://onesourcedt.ubs.com/CEFSWebApp/fwwellness.do?/",
                  data.congrats.cta[0]
                );
              }}
            >
              <OptionImage type="trophy" />
              <OptionText>{data.congrats.cta[0]}</OptionText>
            </OptionExternalLink>
          </Option>
          <Option>
            <OptionInternalLink
              to="/contact"
              onClick={() => {
                this.props.updateLastClick(data.congrats.cta[1]);
              }}
            >
              <OptionImage type="bubbles" />
              <OptionText>{data.congrats.cta[1]}</OptionText>
            </OptionInternalLink>
          </Option>
        </Options>
      </EndingContainer>
    );
  }
}

export default Congrats;
